import styled, { css } from 'styled-components';

export const Placeholder = styled.span`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 20px;

  font-size: 16px;
  line-height: 1;

  opacity: 0.5;

  transition: font-size 0.3s, transform 0.3s;
  pointer-events: none;
`;

export const InputTag = styled.input`
  width: 100%;
  margin: 0;
  padding: 20px;
  padding-bottom: 16px;
  padding-right: ${({ hasToggle }) => hasToggle ? '48px' : '20px'};

  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: inherit;
  opacity: ${({ disabled }) => disabled ? 0.5 : 1};

  border: none;
  outline: none;
  background-color: transparent;

  &::placeholder,
  &::-ms-input-placeholder {
    font-weight: 400;
    font-size: 16px;
    opacity: 0.5;
  }

  @supports (-ms-ime-align: auto) {
    &:not(.placeholder-shown) {

      &::-ms-input-placeholder {
        opacity: 0;
      }

      & + ${Placeholder} {
        transform: translateY(-160%);
        font-size: 14px;
      }
    }
  }

  &:not(:placeholder-shown) + ${Placeholder},
  &:focus + ${Placeholder} {
    transform: translateY(-160%);

    font-size: 14px;
  }

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus {
    -webkit-text-fill-color: ${({ theme }) => theme.black};
    box-shadow: 0 0 0 1000px transparent inset;
    transition: background-color 5000s ease-in-out 0s;
  }

  ${({ floatingPlaceholder }) => floatingPlaceholder && css`
    &::placeholder {
      opacity: 0 !important;
    }

    @supports (-ms-ime-align: auto) {
      &::-ms-input-placeholder {
        opacity: 0;
      }
    }
  `}
`;

export const InputContainer = styled.div`
  position: relative;
  z-index: 1;

  color: ${({ theme }) => theme.black};

  border: 1px solid #ebebeb;

  cursor: pointer;
  transition: border-color 0.3s;

  &:hover {
    border-color: ${({ disabled, theme }) => disabled ? '' : theme.blue};
  }

  ${({ hasError, theme }) => hasError && css`
    border-color: ${theme.red} !important;

    ${Placeholder} {
      color: ${theme.red};
      opacity: 1;
    }
  `}
`;

export const TogglePasswordButton = styled.button`
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  z-index: 2;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 0;
  margin: 0;
  border: none;
  outline: none;
  background: none;
  cursor: pointer;
  color: #999;
  transition: color 0.2s;

  &:hover {
    color: #333;
  }
`;

export const ValidationError = styled.span`
  position: absolute;
  bottom: -7px;
  transform: translateY(100%);
  left: 0;

  font-size: 12px;
  line-height: 14px;
  color: ${({ theme }) => theme.red};
  white-space: nowrap;
`;
